import { render, staticRenderFns } from "./BoxLabelDialog.vue?vue&type=template&id=50d78c30&scoped=true"
import script from "./BoxLabelDialog.vue?vue&type=script&lang=js"
export * from "./BoxLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./BoxLabelDialog.vue?vue&type=style&index=0&id=50d78c30&prod&scoped=true&lang=css"
import style1 from "./BoxLabelDialog.vue?vue&type=style&index=1&id=50d78c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d78c30",
  null
  
)

export default component.exports